module.exports = __webpack_public_path__ + "img/OffSpécifique lumière extérieur.2cdf115e.gif";